import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { PessoaIPIFormComponent } from './pessoa-ipi-form.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        PessoaIPIFormComponent
    ],
    exports: [
        PessoaIPIFormComponent
    ]
})
export class PessoaIPIFormModule { }
